import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Los sermones largos "apagan" el cerebro de tu hijo después de la tercera frase.', 'Las tablas de premios crean niños que solo cooperan si hay un "pago" a cambio.', 'Amenazar con cosas que no vas a cumplir te quita autoridad real ante sus ojos.', 'Repetir órdenes desde otra habitación te convierte en ruido blanco, no en un guía.'];
  return <section className="py-20 px-4 max-w-4xl mx-auto" data-id="element-109">
      <FadeIn data-id="element-110">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-[#2D2A26] mb-8" data-id="element-111">
          El problema no es que tu hijo sea "malo" o "desafiante".
        </h2>
      </FadeIn>

      <FadeIn delay={100} data-id="element-112">
        <p className="font-sans text-lg text-[#2D2A26]/80 text-center mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-113">
          El problema es que, sin querer, le has enseñado que tus primeras 15
          peticiones son ruido de fondo. Él sabe que no hablas en serio hasta
          que tu cara se pone roja y tu voz sube de volumen. Has intentado de
          todo...
        </p>
      </FadeIn>

      <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-[#2D2A26]/5" data-id="element-114">
        <FadeIn delay={200} data-id="element-115">
          <h3 className="font-serif text-2xl font-bold text-[#2D2A26] mb-6 text-center" data-id="element-116">
            Por qué lo que intentaste no funcionó:
          </h3>
        </FadeIn>

        <ul className="space-y-4" data-id="element-117">
          {failedAttempts.map((attempt, index) => <FadeIn key={index} delay={300 + index * 100} data-id="element-118">
              <li className="flex items-start gap-4" data-id="element-119">
                <XCircle className="w-6 h-6 text-[#E8604C] shrink-0 mt-1" data-id="element-120" />
                <span className="font-sans text-lg text-[#2D2A26]/90 leading-relaxed" data-id="element-121">
                  {attempt}
                </span>
              </li>
            </FadeIn>)}
        </ul>

        <FadeIn delay={700} data-id="element-122">
          <p className="mt-8 text-center font-sans font-medium text-[#E8604C] text-lg bg-[#FFF0E6] p-4 rounded-xl" data-id="element-123">
            Mientras sigas usando las mismas herramientas, obtendrás el mismo
            resultado: más gritos y más distancia emocional.
          </p>
        </FadeIn>
      </div>
    </section>;
}